var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusPlatinum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C13.9909 0 18 4.00911 18 9C18 13.9909 13.9909 18 9 18C4.00911 18 0 13.9909 0 9C0 4.00911 4.00911 0 9 0Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9986 2.45508C5.39863 2.45508 2.45312 5.4005 2.45312 9.00055C2.45312 12.6006 5.39854 15.546 8.9986 15.546C12.5987 15.546 15.5441 12.6006 15.5441 9.00055C15.5441 5.4005 12.5986 2.45508 8.9986 2.45508ZM8.9986 13.9096C6.29858 13.9096 4.08954 11.7005 4.08954 9.00055C4.08954 6.30062 6.29867 4.09149 8.9986 4.09149C11.6985 4.09149 13.9077 6.30062 13.9077 9.00055C13.9077 11.7005 11.6985 13.9096 8.9986 13.9096Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPlatinum);
export default __webpack_public_path__ + "static/media/status-platinum.250d19ff935c31ccc8b57ba23c52e9ec.svg";
export { ForwardRef as ReactComponent };